import { isLocalEnv } from '../app/duck';
import {
  Box,
  Flex,
  Grid,
  GridItem,
  Image,
  Text,
  useMediaQuery,
} from '@chakra-ui/react';
import { FC } from 'react';
import { Copyright } from '@lon/shared/components';
import { Form } from './components';
import styles from './AdoptionLogin.module.css';

const AdoptionLogin: FC = () => {
  const [isTablet] = useMediaQuery('(max-width: 1024px)');

  return (
    <Grid
      className={styles.wrapper}
      h="100vh"
      w="100vw"
      gridTemplateAreas={{
        b1024: "'caption form'",
        b375: "'caption' 'form'",
        base: "'form'",
      }}
      gridTemplateColumns={{
        b1440: '700px 1fr',
        b1024: '400px 1fr',
        b744: '1fr',
      }}
      gridTemplateRows={{
        b1024: '1fr',
        b744: '460px 1fr',
        b390: '180px 1fr',
        b375: '100px 1fr',
        base: '1fr',
      }}
    >
      <Box
        position="absolute"
        top="0"
        bottom="0"
        right="0"
        left="0"
        h="100%"
        w="100%"
        backgroundImage={`${isLocalEnv() ? '/' : 'login/'}assets/images/${
          isTablet
            ? 'background-adoption-tablet.svg'
            : 'background-adoption.svg'
        }`}
        role="presentation"
        backgroundSize="cover"
        backgroundRepeat="no-repeat"
        backgroundPosition="bottom"
      />
      <GridItem
        gridArea="caption"
        zIndex={1}
        h="100%"
        w="100%"
        position="relative"
        display={{ b375: 'flex', b320: 'none' }}
        alignItems="center"
        flexDirection="column"
        justifyContent={{ b744: 'space-between', b320: 'center' }}
        pt={{
          b1440: '100px',
          b1024: 8,
          b744: 10,
          b390: 16,
          b320: 6,
        }}
        pb={{ b1024: '0', b744: '48px', b390: 16, b320: 6 }}
        px={{
          b1680: '100px',
          b1440: '64px',
          b1024: 8,
          b744: '48px',
          b390: '24px',
          b320: 6,
        }}
      >
        <Box h="1px" display={{ b744: 'block', b320: 'none' }} />
        <Image
          alignSelf="start"
          src={`${isLocalEnv() ? '/' : 'login/'}assets/images/ali-logo.png`}
          width={{ b1440: '298px', b320: '198px' }}
          height={{ b1440: '48px', b320: '30px' }}
        />
        <Flex
          flexDirection="column"
          gap={{ b1024: 8, b744: 6 }}
          display={{ b744: 'flex', b320: 'none' }}
        >
          <Text
            color="white"
            fontWeight={400}
            fontSize={{ b1440: '1.5rem', b320: '1.25rem' }}
            lineHeight={{ b1440: '2.25rem', b320: '1.8755rem' }}
          >
            {isTablet ? (
              'A POWERFUL, INTERACTIVE MATH TOOL'
            ) : (
              <>
                A POWERFUL,
                <br />
                INTERACTIVE MATH TOOL
              </>
            )}
          </Text>
          <Text
            color="white"
            fontWeight={400}
            fontSize={{ b1440: '1rem', b320: '0.875rem' }}
            lineHeight={{ b1440: '1.625rem', b320: '1.3125rem' }}
          >
            Math Nation is a dynamic online (and printed workbook) resource that
            helps students master middle and high school mathematics. Math
            Nation provides 24-hour access to high-quality instructional videos,
            workbooks, collaborative learning tools, and adaptive assessments
            and support.
          </Text>
          <Text
            color="white"
            fontWeight={400}
            zIndex={1}
            fontSize={{ b1440: '1rem', b320: '0.875rem' }}
            lineHeight={{ b1440: '1.625rem', b320: '1.3125rem' }}
            maxW={{ b1024: '100%', b320: '390px' }}
          >
            To ensure these materials cover every concept students need to
            master to succeed in middle and high school math, we completely
            customize our content to the academic standards of each of our
            individual partner states and work with local universities to
            validate our alignment for each state.
          </Text>
          <Box display={{ base: 'none', b1024: 'block' }}>
            <Copyright
              color="white"
              direction={{
                b1280: 'row',
                base: 'column',
              }}
              align={{
                b1280: 'center',
                base: 'flex-start',
              }}
              justify={{
                b1280: 'flex-start',
                base: 'center',
              }}
              gap={{
                b1280: '24px',
                base: '8px',
              }}
            />
          </Box>
        </Flex>
        <Image
          src={`${isLocalEnv() ? '/' : 'login/'}assets/images/people.png`}
          position={{ b1024: 'static', b320: 'absolute' }}
          bottom={{ b1024: 'auto', b320: '0' }}
          right={{ b1024: 'auto', b320: '48px' }}
          display={{ b744: 'inline', b320: 'none' }}
          width={{
            b1680: '414px',
            b1440: '350px',
            b1024: '270px',
            b320: '250px',
          }}
          height={{
            b1680: '275px',
            b1440: '232px',
            b1024: '180px',
            b320: '166px',
          }}
        />
      </GridItem>
      <GridItem
        h={{
          b744: '54px',
          base: '84px',
        }}
        w="100%"
        zIndex={1}
        px={{
          b744: '48px',
          base: '24px',
        }}
        bgColor="#015286"
        flexDirection="column"
        alignItems="flex-start"
        justifyContent="center"
        display={{ base: 'flex', b1024: 'none' }}
      >
        <Copyright
          color="#B7C5DE"
          fontWeight={500}
          direction={{
            b744: 'row',
            base: 'column',
          }}
          align="flex-start"
          gap={{
            b744: '24px',
            base: '8px',
          }}
        />
      </GridItem>

      <Form />
    </Grid>
  );
};

export default AdoptionLogin;
